import { renderDate } from 'shared/intrasyncUtils';
import { utils } from 'shared/intrasyncUtils';
import { ScheduleGridBodyCellProps } from '@intrasync/react';
import { computed } from 'mobx';

interface HardwareScheduleLeftBodyCellProps extends ScheduleGridBodyCellProps {
    scheduleDate: string;
    rowCount: number;
    rowData: {
        entities: { jobNumber: number }[];
    };
}

const HardwareScheduleLeftBodyCell = (props: HardwareScheduleLeftBodyCellProps) => {
    const { rowCount, rowData, scheduleDate } = props;
    const clientCount = computed(() => {
        return (
            utils.uniqueArray(
                rowData?.entities?.map((i: { jobNumber: number }) => i.jobNumber)
            ).length || 0
        );
    }).get() as number;

    return (
        <div
            style={{
                border: '1px solid #eee',
                ...props.style,
                ...props.styles,
            }}
        >
            <b>{renderDate(scheduleDate)}</b>
            {rowCount >= 1 && (
                <b>
                    {rowCount} {rowCount === 1 ? 'order' : 'orders'}
                </b>
            )}
            {clientCount >= 1 && (
                <b>
                    {clientCount} {clientCount === 1 ? 'client' : 'clients'}
                </b>
            )}
        </div>
    );
};

export default HardwareScheduleLeftBodyCell;